import React from "react";
import TaskStatusOptions from "./task-status-settings";
import ProjectStatusOptions from "./project-status-settings";
import TaskPriorityOptions from "./task-priority-settings";

const ProjectSettingsGroup = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4">
      <TaskStatusOptions />
      <ProjectStatusOptions />
      <TaskPriorityOptions />
    </div>
  );
};

export default ProjectSettingsGroup;
